import { cn } from "@/lib/utils";
import React from "react";
export const Container = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn(`max-w-7xl mx-auto px-4 `, className)} data-sentry-component="Container" data-sentry-source-file="container.tsx">{children}</div>;
};